import { Inject, Injectable } from '@angular/core';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { AbstractUserProvider } from '@sharedservices/identity-auth-angular';

import { WindowToken } from './window';

@Injectable({
    providedIn: 'root'
})
export class InitializationService {

    constructor(
        private userProvider: AbstractUserProvider,
        @Inject(WindowToken) private window: Window
    ) { }

    async run(): Promise<void> {
        datadogLogs.onReady(() => {
            const user = this.userProvider.getCurrentUser();

            datadogLogs.init({
                clientToken: 'pub434a1bde2b22e5d801ef6882d5f11a03',
                service: 'pci_web',
                env: `${this.getEnv()}`,
            });

            datadogLogs.setGlobalContextProperty('application', 'cloud_manager');
            datadogLogs.setGlobalContextProperty('environment', this.getEnv());

            datadogLogs.setUser({
                id: user.userId,
                email: user.email,
                name: user.fullName,
                partnerId: user.partnerId,
                partnerName: user.partnerName,
                isTestPartner: user.isTestPartner,
            });
        });

        datadogRum.onReady(() => {
            if (this.getEnv() === 'prod') {
                const user = this.userProvider.getCurrentUser();

                datadogRum.init({
                    applicationId: '9ce59d4c-1a41-42bf-aca7-f7d186355884',
                    clientToken: 'pub434a1bde2b22e5d801ef6882d5f11a03',
                    service: 'pci_web',
                    env: `${this.getEnv()}`,
                    sessionSampleRate: 100,
                    sessionReplaySampleRate: 100,
                    trackUserInteractions: true,
                    trackResources: true,
                    trackLongTasks: true,
                    defaultPrivacyLevel: 'mask-user-input',
                    allowedTracingUrls: [
                        {
                            match: (url) => url.includes('connectwise.com'),
                            propagatorTypes: ['tracecontext']
                        },
                    ],
                });

                datadogRum.setGlobalContextProperty('application', 'cloud_manager');
                datadogRum.setGlobalContextProperty('environment', this.getEnv());

                datadogRum.setUser({
                    id: user.userId,
                    email: user.email,
                    name: user.fullName,
                    partnerId: user.partnerId,
                    partnerName: user.partnerName,
                    isTestPartner: user.isTestPartner,
                });

                datadogRum.startSessionReplayRecording();
            }
        });
    }

    getEnv() {
        if (this.window.location.hostname.includes('localhost')) {
            return 'local';
        }

        if (this.window.location.hostname.includes('.com')) {
            return 'prod';
        }

        const envRegex = /.*-(dev\d*|qa).*/;
        const envMatch = envRegex.exec(this.window.location.hostname);

        // Fallback to 'dev' if cannot determine environment.
        return envMatch ? envMatch[1] : 'dev';
    }
}
